import { CruxJsDisplayConfig } from "@WahooFitness/crux-js-display-cfg";
import useSWRImmutable from "swr/immutable";

export const useCruxJsDisplayConfig = () => {
  const { data: cruxJsDisplayConfig } = useSWRImmutable("cruxJsDisplayConfig", async () => {
    return await CruxJsDisplayConfig.get();
  });

  return {
    cruxJsDisplayConfig,
  };
};
